/*共通ヘッダー*/
import React, { useCallback } from 'react';
import Moment from 'moment';

// 日付フォーマット(年月日);
const momentFormat = 'YYYY年MM月DD日';

interface Props {
  reception_cd: string;
  is_staff: boolean;
  status_name: string;
  email: string;
  application_date: string;
  application_product: string;
  user_name: string;
  user_kana_name: string;
  status_code: number;
  receptionHitsoryCallback?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  is_history: boolean;
  message: string;
  desired_amount_before: string;
  desired_amount_application: string;
  desired_amount_after: string;
}

const TopArea: React.FC<Props> = ({
  reception_cd,
  is_staff,
  status_name,
  email,
  application_date,
  application_product,
  user_name,
  user_kana_name,
  status_code,
  receptionHitsoryCallback,
  is_history,
  message,
  desired_amount_before,
  desired_amount_application,
  desired_amount_after,
}) => {
  return (
    <div className="top-area mx-auto px-0 col-11 col-xs-10 col-lg-9">
      {is_staff && is_history && (
        // 案件履歴画面
        <>
          <div className="top-area-continer left">
            <ul className="top-area-header">
              <li>案件番号：{reception_cd}</li>
            </ul>
            <ul className="top-area-header">
              <li>{status_name}</li>
              <li>氏名：{user_name}</li>
            </ul>
          </div>
        </>
      )}
      {is_staff && !is_history && (
        // 行員
        <>
          <div className="top-area-continer left">
            <ul className="top-area-header">
              <li>
                仮申込：
                {application_date.length === 0 ? '' : Moment(application_date).format(momentFormat)}
              </li>
              <li>案件番号：{reception_cd}</li>
              <li>
                {status_code}：{status_name}
              </li>
            </ul>
            <ul className="top-area-header">
              <li>氏名：{user_name}</li>
              <li>カナ：{user_kana_name}</li>
              <li>最新ログインID：{email}</li>
            </ul>
            <ul className="top-area-header">
              <li>お借入希望額（事前審査時）：{desired_amount_before}</li>
              <li>お借入希望額（本申込時）：{desired_amount_application}</li>
              <li>お借入希望額（本審査後）：{desired_amount_after}</li>
            </ul>
          </div>
          {/* //TODO degawa 入力履歴画面の使用が確定するまでコメントアウト */}
          {/* <div className="top-area-continer right">
            <ul className="top-area-header btn-hitsory">
              <li>
                <p>
                  <a
                    href="#"
                    target="_blank"
                    className="btn btn-main-color"
                    onClick={receptionHitsoryCallback}
                  >
                    履 歴
                  </a>
                </p>
              </li>
            </ul>
          </div> */}
        </>
      )}
      {!is_staff && (
        // 申込人
        <div className="top-area-continer left">
          {message && (
            <ul className="top-area-header message">
              <li>{message}</li>
            </ul>
          )}
          <ul className="top-area-header">
            <li>案件番号：{reception_cd}</li>
            <li>
              お申込み日：
              {application_date.length === 0 ? '' : Moment(application_date).format(momentFormat)}
            </li>
            <li>お申込み商品：{application_product}</li>
            <li>状態：{status_name}</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default TopArea;
